import { useV2ListProjectServicesQuery } from "@generated";

export const useProjectServices = (projectId: string) => {
  const { data, isLoading } = useV2ListProjectServicesQuery({
    filter: { project: projectId },
  } as any);
  const services = (data?.data ?? []).map((s: any) => ({
    id: String(s.id),
    name: s.attributes?.name ?? "",
  }));
  return { services, isLoading };
};
